import React, { useRef, useState, useEffect } from "react";
import { useTranslation, Trans } from "react-i18next";
import { useNavigate } from "react-router-dom";

// Style
import { Container, CheckoutButton, RadioContainer, Label } from "./styles";
import { Radio } from "../radio";
import { StepComponentProps } from "../steps";
import { useMediaQuery } from "~/hooks/useMediaQuery";

const LAST_STEP = "store-region-radio";

export const REGIONS_ARRAY = [
  {
    // Region: North America
    id: "north-america",
    label: "onboarding.customization-store.region.radio_northamerica",
    hasTransElem: false,
  },
  {
    // Region: Europe
    id: "europe",
    label: "onboarding.customization-store.region.radio_europe",
    hasTransElem: false,
  },
  {
    // Region: Asia
    id: "asia",
    label: "onboarding.customization-store.region.radio_asia",
    hasTransElem: false,
  },
  {
    // Region: Global
    id: "global",
    label: "onboarding.customization-store.region.radio_global",
    hasTransElem: true,
  },
];

type RegionProps = StepComponentProps & {};

export const Region = ({
  onboardingChoices,
  setOnboardingChoices,
}: RegionProps) => {
  const { t } = useTranslation();
  const isAboveMobile = useMediaQuery("mobileL");

  const selectedRegion = onboardingChoices?.selectedRegion;

  const handleSelectRegion = (region: string) => {
    setOnboardingChoices((prev) => ({
      ...prev,
      selectedRegion: region,
    }));
  };

  return (
    <Container data-testid="region">
      {REGIONS_ARRAY.map((region) => {
        const { id: regionId, label, hasTransElem } = region;
        const checked = regionId === selectedRegion;

        return (
          <Radio
            context="store-region-selection"
            key={`store-region-selection-${regionId}`}
            optionId={regionId}
            checked={checked}
            isFullWidth={!isAboveMobile}
            label={
              <Label checked={checked} key={`store-region-${regionId}`}>
                {hasTransElem ? (
                  <Trans
                    i18nKey={label}
                    components={{
                      1: <span className="all-regions" />,
                    }}
                  />
                ) : (
                  t(label)
                )}
              </Label>
            }
            changeSeletedOption={() => handleSelectRegion(regionId)}
          />
        );
      })}
    </Container>
  );
};
